import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import { DESKTOP_MIN } from '../../../../../lib/responsive';

import ChecklistTaskCompleteDeleteButtons from '../../ChecklistTaskCompleteDeleteButtons';
import ChecklistDateNoteForm from '../../ChecklistDateNote';
import ChecklistTitleForm from '../ChecklistTitleForm';
import ChecklistTaskProTip from '../../ChecklistTaskProTip';
import ChecklistTaskSponsoredContent from '../../ChecklistTaskSponsoredContent';
import ChecklistAssignTaskButton from '../../ChecklistAssignTaskButton';

class ChecklistDesktopTask extends Component {
  renderTitle = () => {
    const { title, isCustomTask, taskId, editCustomTask } = this.props;

    if (isCustomTask) {
      return (
        <ChecklistTitleForm
          key={taskId}
          viewValueClassName="checklist__task-header"
          initialValues={{ title }}
          autoFocus
          onSubmit={(formValues) => {
            editCustomTask(formValues, taskId);
          }}
        />
      );
    }

    return <h1 className="checklist__task-header">{title}</h1>;
  };

  renderTaskProTip = () => {
    const { sponsoredLink, description, url, urlText } = this.props;

    if (!description) return null;

    if (sponsoredLink) {
      return <ChecklistTaskProTip copy={description} url={url} urlText={urlText} />;
    }

    return <ChecklistTaskProTip copy={description} url={url} urlText={urlText} fullWidth />;
  };

  renderSponsoredContent = () => {
    const { sponsoredLink, sponsoredLinkText, isSponsoredLinkFromZola } = this.props;

    if (!sponsoredLink) return null;

    return (
      <ChecklistTaskSponsoredContent
        url={sponsoredLink}
        urlText={sponsoredLinkText}
        isSponsoredLinkFromZola={isSponsoredLinkFromZola}
      />
    );
  };

  render() {
    const { taskId, isCustomTask } = this.props;
    return (
      <Media query={`(min-width: ${DESKTOP_MIN}px)`}>
        <div className="checklist__task-desktop">
          <div className="checklist__task-desktop__header">
            {this.renderTitle()}
            <ChecklistAssignTaskButton />
          </div>
          <ChecklistDateNoteForm key={taskId} isCustomTask={isCustomTask} />
          <div className="checklist__taskLink--container">
            {this.renderTaskProTip()}
            {this.renderSponsoredContent()}
          </div>
          <div className="checklist__task-desktop__footer">
            <ChecklistTaskCompleteDeleteButtons deleteLabel="Delete" />
          </div>
        </div>
      </Media>
    );
  }
}

ChecklistDesktopTask.propTypes = {
  taskId: PropTypes.string.isRequired,
  isCustomTask: PropTypes.bool,
  sponsoredLink: PropTypes.string,
  sponsoredLinkText: PropTypes.string,
  url: PropTypes.string,
  urlText: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  editCustomTask: PropTypes.func,
  isSponsoredLinkFromZola: PropTypes.bool,
};

export default ChecklistDesktopTask;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTask/ChecklistDesktopTask/ChecklistDesktopTask.jsx